<template>
<header>
    <div class="container">

        <div class="row mx_0_5">
            <div class="col px_0_5 items_center">

                <div class="row">
                    <div class="col_12">
                        <span class="club_name">TAEGUK Essen e.V.</span>
                    </div>
                    <div class="col_12">
                        <span class="club_slogan">...der Weg ist das Ziel!</span>
                    </div>
                </div>

            </div>
            <div class="col_auto px_0_5">

                <img src="/images/logo.png" alt="Logo">
                    
            </div>
        </div>
        
    </div>
</header>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Header'
});
</script>
